module.exports = __webpack_public_path__ + "fd3d32781bf80749405c622c05bd3b5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_5.jpg
// module id = 1714
// module chunks = 5